import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'src/components/tooltip';
import Icon from 'shared/components/icon';
import Stamp, {BLUE} from 'src/components/Stamp/Stamp';

const propTypes = {
  showTooltipFlag: PropTypes.bool,
};

const CompleteProfileText = ({showTooltipFlag = false}) => {
  const infoText = 'Complete profile to check eligibility';
  if (!showTooltipFlag) {
    return (
      <Stamp color={BLUE}>
        <a href="/account-settings">
          <div className="college-earnings-no-earnings-status-text-with-cta">
            <div className="college-earnings-no-earnings-status-text-content">{infoText}</div>

            <div className="college-earnings-no-earnings-status-cta-icon">
              <Icon iconType="chevron-right" />
            </div>
          </div>
        </a>
      </Stamp>
    );
  }

  return (
    <div className="college-earnings-no-earnings-status-text-content">
      <Tooltip title={infoText}>
        <div>
          <Stamp color={BLUE} className="flag">
            <Icon iconType="flag" color="blue" />
          </Stamp>
        </div>
      </Tooltip>
    </div>
  );
};

CompleteProfileText.propTypes = propTypes;
export default CompleteProfileText;
